var _rect, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoundDollarWithCursor = function SvgRoundDollarWithCursor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    transform: "translate(0 0.5)",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4298,
    cy: 33.93,
    r: 22.5702,
    fill: "url(#paint0_linear_761_16302)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.43,
    cy: 33.93,
    r: 17.9234,
    stroke: "#ABD9FE",
    strokeWidth: 1.32766
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5496 33.5984L37.5449 32.8947V28.394H38.0228C39.0982 28.394 39.9745 29.3366 39.9745 30.4917C39.9745 31.036 40.4259 31.4874 40.9702 31.4874C41.5146 31.4874 41.966 31.036 41.966 30.4917C41.966 28.2347 40.2002 26.4025 38.0228 26.4025H37.5449V25.6325C37.5449 25.0881 37.0935 24.6367 36.5491 24.6367C36.0048 24.6367 35.5534 25.0881 35.5534 25.6325V26.4025H34.6904C32.7255 26.4025 31.119 28.0621 31.119 30.0934C31.119 32.4699 32.4998 33.2267 33.5486 33.5984L35.5534 34.3021V38.7895H35.0754C34 38.7895 33.1238 37.8469 33.1238 36.6918C33.1238 36.1475 32.6724 35.6961 32.128 35.6961C31.5837 35.6961 31.1323 36.1475 31.1323 36.6918C31.1323 38.9489 32.8981 40.781 35.0754 40.781H35.5534V41.5643C35.5534 42.1087 36.0048 42.5601 36.5491 42.5601C37.0935 42.5601 37.5449 42.1087 37.5449 41.5643V40.7943H38.4079C40.3728 40.7943 41.9792 39.1347 41.9792 37.1034C41.966 34.7136 40.5852 33.9569 39.5496 33.5984ZM34.2125 31.7264C33.5354 31.4874 33.1238 31.2617 33.1238 30.1067C33.1238 29.164 33.8274 28.4073 34.7037 28.4073H35.5667V32.2044L34.2125 31.7264ZM38.4079 38.8028H37.5449V35.0057L38.8858 35.4704C39.5629 35.7094 39.9745 35.9351 39.9745 37.0901C39.9745 38.0328 39.2708 38.8028 38.4079 38.8028Z",
    fill: "#87C8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.605 58.4631L46.1628 38.2153L63.3146 50.414L54.7414 51.8714L54.2484 52.1165L49.605 58.4631Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2353 57.363L57.0075 60.0785L48.7046 47.065L53.0311 44.3093L61.2353 57.363Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4033 56.7889L57.2383 58.1638L51.7341 49.5072L53.8951 48.1317L59.4033 56.7889Z",
    fill: "#69B6F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9443 41.0435L50.349 55.1884L53.4867 50.9268L53.9979 50.6591L60.0261 49.6343L47.9443 41.0435Z",
    fill: "#69B6F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 35.4216,
    cy: 66.0774,
    rx: 22.9143,
    ry: 1.96408,
    fill: "url(#paint1_linear_761_16302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_16302",
    x1: 5.74056,
    y1: 10.3459,
    x2: 33.9405,
    y2: 55.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_16302",
    x1: 63.5436,
    y1: 64.3752,
    x2: 60.879,
    y2: 78.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoundDollarWithCursor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "round-dollar-with-cursor.0105b19c1c0a8663fdb45e9b018a0b42.svg";